import { render, staticRenderFns } from "./TextPopup.vue?vue&type=template&id=bba88ca0"
import script from "./TextPopup.vue?vue&type=script&lang=js"
export * from "./TextPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports